export default __webpack_public_path__ + "static/media/main-icon3.c0a3d2d3.png";